function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, matchPath } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import findIndex from 'lodash/findIndex';
import findLastIndex from 'lodash/findLastIndex';
import { setPageTransitioning } from '@signal/core/app';
import isServer from '@signal/utils/env/isServer';
import { Wrapper } from './styles'; // This returns a childFactory to provide to TransitionGroup

var childFactoryCreator = function childFactoryCreator(props) {
  return function (child) {
    return React.cloneElement(child, props);
  };
};

export var AnimatedSwitch =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AnimatedSwitch, _React$PureComponent);

  function AnimatedSwitch() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnimatedSwitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimatedSwitch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      location: _this.props.location,
      prevLocation: {}
    });

    _defineProperty(_assertThisInitialized(_this), "onExit", function () {
      _this.props.setPageTransitioning(true);
    });

    _defineProperty(_assertThisInitialized(_this), "onExited", function () {
      _this.props.setPageTransitioning(false);
    });

    return _this;
  }

  _createClass(AnimatedSwitch, [{
    key: "getTimeout",
    value: function getTimeout(animation) {
      switch (animation) {
        case 'slide-left':
          return {
            enter: 275,
            exit: 475
          };

        case 'slide-right':
          return {
            enter: 325,
            exit: 225
          };

        case 'modal-in':
          return {
            enter: 300,
            exit: 300
          };

        case 'modal-out':
          return {
            enter: 250,
            exit: 250
          };

        default:
          return 0;
      }
    }
  }, {
    key: "getOverride",
    value: function getOverride() {
      var _this$state = this.state,
          location = _this$state.location,
          prevLocation = _this$state.prevLocation;
      var overrides = this.props.overrides;
      var i = overrides.length;

      while (i > 0) {
        var animationOverride = overrides[i - 1];
        var animation = animationOverride(location, prevLocation);
        if (animation) return animation;
        i--;
      }
    }
  }, {
    key: "findRouteStack",
    value: function findRouteStack() {
      var _this$state2 = this.state,
          pathname = _this$state2.location.pathname,
          prevPathname = _this$state2.prevLocation.pathname;
      var stacks = this.props.stacks;
      return stacks.find(function (stack) {
        return stack.find(function (path) {
          return matchPath(pathname, {
            path: path,
            exact: true
          });
        }) && stack.find(function (path) {
          return matchPath(prevPathname, {
            path: path,
            exact: true
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          location = _this$props.location,
          routeKeyGenerator = _this$props.routeKeyGenerator,
          animate = _this$props.animate;
      var routeKey = routeKeyGenerator(location);
      /**
       * Do not wrap in transition group if animate is false.
       */

      if (!animate) {
        return React.createElement(Switch, {
          location: location,
          key: routeKey
        }, children);
      }

      var _this$transition = this.transition,
          animation = _this$transition.animation,
          timeout = _this$transition.timeout;
      var hasAnimation = animation.length > 0;
      return React.createElement(TransitionGroup, {
        enter: hasAnimation,
        exit: hasAnimation,
        childFactory: childFactoryCreator({
          classNames: animation,
          timeout: timeout
        })
      }, React.createElement(CSSTransition, {
        key: routeKey,
        classNames: animation,
        timeout: timeout,
        onEnter: this.onExit,
        onExited: this.onExited
      }, React.createElement(Wrapper, null, React.createElement(Switch, {
        location: location
      }, children))));
    }
  }, {
    key: "transition",
    get: function get() {
      /**
       * @todo Revisit disabling route transitions on desktop
       * @body The current solution is more of a hack/quick fix.
       */
      // Disable transitions on desktop
      if (!isServer() && window.outerWidth >= 1024) return {
        animation: '',
        timeout: 0
      };
      var _this$state3 = this.state,
          pathname = _this$state3.location.pathname,
          prevPathname = _this$state3.prevLocation.pathname;
      var animation = this.getOverride() || '';

      if (!animation.length) {
        var stack = this.findRouteStack();

        if (stack) {
          var pathIndex = findIndex(stack, function (path) {
            return matchPath(pathname, {
              path: path,
              exact: true
            });
          });
          var prevPathIndex = findLastIndex(stack, function (path) {
            return matchPath(prevPathname, {
              path: path,
              exact: true
            });
          });

          if (pathIndex !== prevPathIndex && pathIndex >= 0 && prevPathIndex >= 0) {
            animation = pathIndex > prevPathIndex ? 'slide-left' : 'slide-right';
          }
        }
      }

      return {
        animation: animation,
        timeout: this.getTimeout(animation)
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, _ref2) {
      var location = _ref.location;
      var prevLocation = _ref2.location;

      if (location !== prevLocation) {
        return {
          location: location,
          prevLocation: prevLocation
        };
      }

      return null;
    }
  }]);

  return AnimatedSwitch;
}(React.PureComponent);

_defineProperty(AnimatedSwitch, "propTypes", {
  location: PropTypes.object.isRequired,

  /**
   * If false, the component will not add the transition group components
   * and no animations or transitions will happen.
   */
  animate: PropTypes.bool
});

_defineProperty(AnimatedSwitch, "defaultProps", {
  animate: false
});

var mapDispatchToProps = {
  setPageTransitioning: setPageTransitioning
};
export default connect(null, mapDispatchToProps)(AnimatedSwitch);